import { ShippingPackApiDto } from '@b2x/storefront-api-js-client/src';

import { AlertFromDto } from './AlertFromDto';
import { CartSku } from './CartSku';
import { appConfig } from './config';
import { Div, Span, Ul } from './HTMLElement';
import { t } from './i18n/i18n';

export interface CartPacksProps {
  compactLayout?: boolean;
  packs: Array<ShippingPackApiDto>;
  readOnly?: boolean;
}

export const CartPacks = ({ compactLayout, packs, readOnly }: CartPacksProps) => {
  return (
    <Div background="white" className="cart-packs" marginBottom={3} padding={3}>
      {packs.map((pack) => (
        <Div className="cart-pack" key={pack.warehouseId}>
          {appConfig.showWarehouseAlias && (
            <Div className="pt-3 pb-2 cart-pack-warehouse">
              <Span className="fw-bold pe-1">{t('cart.productTile.shippedBy')}</Span>
              <Span>{pack.warehouseAlias}</Span>
            </Div>
          )}
          {pack.cartSkus?.map((cartSku, index) => (
            <CartSku
              cartSku={cartSku}
              compactLayout={compactLayout}
              index={index}
              key={cartSku.id}
              readOnly={readOnly}
              // TO DO: Da rimuovere quando verrà gestito il nuovo flag per omaggio a carrello
              temporaryPropToDisableProductPageLink={!cartSku.canEditQuantity}
              temporaryPropToDisableWishlistButton={!cartSku.canEditQuantity}
            />
          ))}
          {pack.alerts && pack.alerts.length > 0 && (
            <Div className="cart-pack-alerts" paddingBottom={1}>
              <Ul uiClassName={{ bs5: 'list-unstyled' }}>
                {pack.alerts.map((alert) => (
                  <li key={alert.code}>
                    <AlertFromDto alert={alert} light small />
                  </li>
                ))}
              </Ul>
            </Div>
          )}
        </Div>
      ))}
    </Div>
  );
};
